import React from 'react'
import styled from '@emotion/styled'

interface ICode {
  /**
   * Should be a component to render as code.
   */
  children?: React.ReactNode
}

const Code: React.FC<ICode> = ({ children }) => {
  return (
    <>
      <StyledCode>{children}</StyledCode>
    </>
  )
}

export default Code

const StyledCode = styled('code')(({ theme }) => ({
  borderRadius: '2px',
  color: '#000',
  fontSize: '.8rem',
  margin: `0 ${theme.space[1]}px`,
  padding: `${theme.space[1]}px ${theme.space[1]}px`,
  whiteSpace: 'pre-wrap',
  backgroundColor: 'rgb(245, 242, 240)',
  fontFamily: 'Roboto Mono,Monaco,courier,monospace'
}))
